<template>
  <v-app>
    <component :is="layout">
      <router-view></router-view>
    </component>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  computed: {
    layout () {
      const layoutName = this.$route.meta.layout || 'default'
      return () => import(`@/layouts/${layoutName}.vue`)
    }
  }
}
</script>
